const AccountSettings = () =>
  import("../settings/AccountSettings/views/AccountSettingsForm.vue");
const Settings = () => import("../settings/views/Settings.vue");
const Billing = () => import("../settings/Billing/views/Billing.vue");
import RoleRoutes from "../settings/RolesAndPermissions/routes";
import BillingRoutes from "../settings/Billing/routes";
export default [
  {
    path: "",
    component: Settings,
  },
  {
    path: "account-settings",
    component: AccountSettings,
  },
  {
    path: "billing",
    // component: AllReports,
    redirect: "/admin/organization/system-settings/billing/order-history",
    component: Billing,
    children: BillingRoutes,
  },
  {
    path: "roles",
    redirect: "/admin/organization/system-settings/roles/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: RoleRoutes,
  },
];
